module.exports = __webpack_public_path__ + "static/media/CDAC.09e47ace.png";